<template>
<v-container>
  <v-row justify="center">
    <v-col>
      <span class="title">Access Restricted</span>
    </v-col>
    <v-col cols="12">You do not have the required permissions to view this client.</v-col>
  </v-row>
</v-container>
</template>

<style>
</style>

<script>
export default {};
</script>
